{
  "agb-form": {
    "text": {
      "accept": "I accept the ",
      "agb": "General Terms and Conditions"
    }
  }
}
